import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]

import { ref, computed, onMounted } from 'vue';
import { useMQ } from '@/js/lib/helper/media-query';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { credentials } from '@/js/lib/api/user';
import { useCartStore } from '@/js/lib/store/cart';
import { useCommonStore } from '@/js/lib/store/common';
import { useNotificationStore } from '@/js/lib/store/notification';
import { useTimelineStore } from '@/js/lib/store/timeline';
import { useTodoStore } from '@/js/lib/store/todo';
import { useUserStore } from '@/js/lib/store/user';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import CartIcon from '@/icon/vue/cart.svg';
import HeartIcon from '@/icon/vue/heart.svg';
import HeaderAccount from './HeaderAccount.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderIcons',
  setup(__props) {

const commonStore = useCommonStore();
const userStore = useUserStore();
const notificationStore = useNotificationStore();
const todoStore = useTodoStore();
const timelineStore = useTimelineStore();
const cartStore = useCartStore();
const { isSp } = useMQ();
const isShowMenuPc = ref(false);
const isShowMenuSp = ref(false);
const isPreSeller = userStore.hasCredential(credentials.preSeller);
const activityCount = computed(() => (isPreSeller ? todoStore.totalCount + notificationStore.updatedCount : commonStore.activityCount));
const onClickSignin = () => {
  signinSignup({
    active: 'signin',
    callback: () => {
      window.location.reload();
    },
  });
};
const onClickSignup = () => {
  signinSignup({
    active: 'signup',
    callback: () => {
      window.location.reload();
    },
  });
};
const onClickAvatar = (e: Event) => {
  if (isSp.value) {
    e.preventDefault();
  }
  isShowMenuSp.value = !isShowMenuSp.value;
};

onMounted(() => {
  if (userStore.isAuthenticated && !isPreSeller) {
    commonStore.checkActivity();
  }
  cartStore.loadBaskets();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.$style.icons)
  }, [
    (_unref(userStore).isAuthenticated)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "https://help.iichi.com/hc/ja/",
              target: "_blank",
              class: _normalizeClass(_ctx.$style.text)
            }, "ヘルプ", 2)
          ]),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("li", {
            class: _normalizeClass(_ctx.$style.accountMenu),
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isShowMenuPc.value = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isShowMenuPc.value = false))
          }, [
            _createElementVNode("a", {
              href: "/your/dashboard",
              class: _normalizeClass(_ctx.$style.avatar),
              "aria-label": "マイページ",
              onClick: onClickAvatar
            }, [
              (_unref(userStore).picturePath)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(dynamicImageUrl)(_unref(userStore).picturePath, 100, 100),
                    alt: "",
                    width: "32",
                    height: "32"
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (activityCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.$style.updated)
                  }, null, 2))
                : _createCommentVNode("", true)
            ], 2),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createVNode(HeaderAccount, {
              class: _normalizeClass([_ctx.$style.headerAccount, isShowMenuPc.value && _ctx.$style.isShowMenuPc, isShowMenuSp.value && _ctx.$style.isShowMenuSp])
            }, null, 8, ["class"])
          ], 34)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "/sell",
              class: _normalizeClass([_ctx.$style.text, _ctx.$style.sell])
            }, "ショップをつくる", 2)
          ]),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "/signup",
              class: _normalizeClass(_ctx.$style.text),
              onClick: _withModifiers(onClickSignup, ["prevent"])
            }, "会員登録", 2)
          ]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              href: "/signin",
              class: _normalizeClass(_ctx.$style.text),
              onClick: _withModifiers(onClickSignin, ["prevent"])
            }, "ログイン", 2)
          ])
        ], 64)),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: "/likes/item",
        class: _normalizeClass([_ctx.$style.button, _ctx.$style.favorite]),
        "aria-label": "お気に入り"
      }, [
        _createVNode(SvgIcon, { svg: _unref(HeartIcon) }, null, 8, ["svg"]),
        _cache[7] || (_cache[7] = _createTextVNode()),
        (_unref(timelineStore).isUpdated)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_ctx.$style.updated)
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _cache[10] || (_cache[10] = _createTextVNode()),
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        href: "/cart",
        class: _normalizeClass([_ctx.$style.button, _ctx.$style.cart]),
        "aria-label": "カート"
      }, [
        _createVNode(SvgIcon, { svg: _unref(CartIcon) }, null, 8, ["svg"]),
        _cache[8] || (_cache[8] = _createTextVNode()),
        (_unref(cartStore).itemCount > 0)
          ? (_openBlock(), _createElementBlock("em", {
              key: 0,
              class: _normalizeClass(_ctx.$style.cartCount)
            }, _toDisplayString(_unref(cartStore).itemCount), 3))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 2))
}
}

})